import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import UseSvg from "@SharedVueComponents/Svg/UseSvg.vue";
import { pushEvent } from "@/services/dataLayerLogin";
import { store } from "@/state/store";
import { authenticate } from "@/services/ocmAuthentication";
import { loadScript } from "@/services/utils";
import { useI18n } from "vue-i18n";
import { onBeforeUnmount, onMounted, ref } from "vue";
import OcmMessenger from "ocm_mercurius_messenger";
import { messengerPublicationTypes } from "@ocm/services/services.constants.js";

const appleSdkUrl = "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppleLogin',
  setup(__props) {

const { t } = useI18n();
const messangerId = ref<number | null>(null);
const initialized = ref(false);

onMounted(() => {
	if (store.isModal) {
		messangerId.value = OcmMessenger.subscribe(messengerPublicationTypes.REQUEST_LOGIN, loadSDK);
	} else {
		loadSDK();
	}
});

onBeforeUnmount(() => {
	if (store.isModal) messangerId.value && OcmMessenger.unsubscribe(messangerId.value);
});

async function loadSDK() {
	if (initialized.value) return;
	return loadScript(appleSdkUrl)
		.then(() => {
			initialized.value = true;
		})
		.catch(() => {
			pushEvent("apple_load_error");
		});
}

function startAppleLogin() {
	// todo todo TUB-18950: remove suffix after AB-Test
	const suffix = store.abTestIsTestPage && !store.abTestFirstStep ? "2" : "";
	pushEvent(store.isModal ? "AppleBtnClick" : `AppleButton${suffix}`);
	store.globalErrorMessages = [];
	if (initialized.value) {
		appleAuthentication();
	} else {
		loadSDK().then(appleAuthentication);
	}
}

function appleAuthentication() {
	if (typeof window.AppleID !== "object") {
		const errorMessage = t(`errorMessages.httpError`);
		store.isSocialLogin = true;
		store.globalErrorMessages = [errorMessage];
		pushEvent("apple_click_error", errorMessage);
		return false;
	}

	const appleSignin = window.AppleID.auth.signIn();

	appleSignin
		.then((event) => {
			const appleTokenId = event.authorization.id_token;
			startOcmLogin(appleTokenId);
		})
		.catch((error) => {
			console.error(error);
		});
}

function startOcmLogin(appleAuthorizationIdToken: string) {
	const authorationData = {
		id_token: appleAuthorizationIdToken,
	};

	authenticate(authorationData, "apple").then((ok) => console.log("appleLogin", ok));
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: "flex-center m-2 flex rounded-3xl border border-solid border-[#dadce0] bg-white p-2.5 hover:border-[#d2e3fc] hover:bg-[rgba(66,133,244,.04)]",
    onClick: startAppleLogin
  }, [
    _createVNode(UseSvg, {
      "svg-id": "social-apple",
      class: "svg-icon flex-icon social-icon pointer-events-none h-[18px] w-[18px]"
    })
  ]))
}
}

})